export default "__VITE_ASSET__DiB1STnL__"